import { CategoryTip } from '@model/category/CategoryTip'

export function getParentsArray(tree: CategoryTip[], currentId: number): CategoryTip[][] {
  const result: CategoryTip[][] = []

  function findNodeAndParents(node: CategoryTip, parentId: number, parentsArray: CategoryTip[]): void {
    const newNode: CategoryTip = { ...node }
    parentsArray.push(newNode)

    if (node.id === parentId) {
      result.push([...parentsArray])
    } else {
      for (const child of node.children) {
        findNodeAndParents(child, parentId, parentsArray)
      }
    }

    parentsArray.pop()
  }

  for (const node of (tree || [])) {
    findNodeAndParents(node, currentId, [])
  }

  return result
}
